// extracted by mini-css-extract-plugin
export default {"main":"CartItem_main__lOw2u","main2":"CartItem_main2__0r-Hn","main1":"CartItem_main1__pmfSi","mrp":"CartItem_mrp__GTvP5","main3":"CartItem_main3__XRxu-"};